// import { SelectOption } from '@/types/form.type.ts';

export enum CarDocumentType {
    Document = 'document',
    AvtocodReport = 'avtocod_report',
    DiagnosticCard = 'diagnostic_card',
}

// export function getCarDocumentTypeLabel(type: CarDocumentType): string {
//     switch (type) {
//         case CarDocumentType.Document:
//             return 'Документ';
//         case CarDocumentType.AvtocodReport:
//             return 'Отчет Автокод';
//         case CarDocumentType.DiagnosticCard:
//             return 'Диагностическая карта H-Promise';
//     }
// }

// export function getCarDocumentTypeSelectOptions(): SelectOption[] {
//     const options: SelectOption[] = [];
//
//     Object.values(CarDocumentType).forEach((type: CarDocumentType) => {
//         options.push({
//             label: getCarDocumentTypeLabel(type),
//             value: type,
//         });
//     });
//
//     return options;
// }
